import BlogCollectionGrid from "./BlogCollectionGrid";

export default BlogCollectionGrid;